import React, { Component, type JSX } from 'react';
import { CartItem } from './CartItem';
import { getExamentrainingDatesLabel } from '../../../models/Examentraining';
import { CartListTraining } from '../Checkout.interface';
import { Article } from '../../../models/Article';
import { cart } from '../../Cart/Cart';


interface CartListProps {
  isPreRegisterOnly: boolean;
  cartList: (Article|CartListTraining)[];
}

function cartItemIsCartListTraining(item: Article|CartListTraining): item is CartListTraining {
  return 'id_training' in item;
}

export function cartItemIsArticle(item: Article|CartListTraining): item is Article {
  return 'id_item' in item;
}

/**
 * Render the contents of the shopping cart. The cart can contain both
 * shop-items like Lyceo Samenvatting or Trainings (examntraining or codelab).
 * Trainings can have add-ons like oefenopgaven.
 */
export class CartList extends Component<CartListProps>{

  public render(): JSX.Element {
    const { isPreRegisterOnly, cartList } = this.props;

    // Create the list the training items. These trainings can
    // have the subItems (in cart) or upsell items (not yet in cart).
    const trainingsItems = cartList
      .filter(item => cartItemIsCartListTraining(item))
      .map((training: CartListTraining) => <CartItem
        key={training.id_training}
        id={training.id_training}
        subject={training.vak_naam}
        level={training.vak_niveau}
        title={`${training.product_type} | ${training.vak_naam} - ${training.vak_niveau}`}
        /* eslint-disable-next-line max-len */
        subtitle={`${getExamentrainingDatesLabel(training)}, ${training.loc_straat} ${training.loc_nr}, ${training.loc_stad}`}
        label={training.product_naam}
        price={training.prijs}
        subItems={training.subItems}
        upsellItems={training.upsellItems}
        deleteMethod={/* istanbul ignore next */ (id: string): Promise<void> => cart.removeTraining(id)}
      />);

    // Create the list of articles (that can be bought without a training).
    const acticleItems = cartList
      .filter(item => cartItemIsArticle(item))
      .map((article: Article) => <CartItem
        key={article.id_item}
        id={article.id_item}
        subject={article.subject}
        level={article.level}
        title={`${article.title} | ${article.subject} - ${
          (article.title === 'Lyceo Samenvatting' && article.level === 'VMBO B')
            ? 'VMBO BB/KB'
            : article.level}`}
        label="Geen verzendkosten"
        price={article.price}
        deleteMethod={/* istanbul ignore next */ (id: string): Promise<void> => cart.removeShopItem(id)}
      />);

    return (
      <div className="checkout-list">
        {isPreRegisterOnly
        && <div className="checkout-list__form-notice">
          {/* eslint-disable-next-line max-len */}
          Let op! U doet een reservering en hoeft nog niet te betalen. Vul het formulier in en klik op Reserveren om de training te reserveren. Op de dag van de examenuitslag kunt u de reservering definitief maken of annuleren.
        </div>}

        <h5 className="checkout__title">
          Winkelwagen
        </h5>

        <ul className="checkout-list__product-list shoppingcart-item">
          {trainingsItems}
          {acticleItems}
        </ul>
      </div>
    );
  }
}
